import { render, staticRenderFns } from "./balancing-approval-submit-confirmation.vue?vue&type=template&id=3605e527&scoped=true&"
import script from "./balancing-approval-submit-confirmation.vue?vue&type=script&lang=js&"
export * from "./balancing-approval-submit-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./balancing-approval-submit-confirmation.vue?vue&type=style&index=0&id=3605e527&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605e527",
  null
  
)

export default component.exports